import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';

function TrnAbst_popup() {

    const [data, setData] = useState({});
    const [emogList, setEmogList] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('trnAbstData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/trnAbstPstDetail.do', {
                params: sendData
            });
            setData(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };

    const [searchParams, setSearchParams] = useState({
        TYPE: '',
        SPK_NM: '',
        EMOGCODE: '',
        SCHDUL_STDT: '',
        SCHDUL_ENDT: '',
        ACD_NM: '',
        BIGO: '',
    });

    const isUpdate = sendData.flag === 'update';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/trmsapi/trnlst/trmsEmogList.do', {
                    params: {}
                });
                setEmogList(response.data.trnEmogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        popupData();
    }, []);

    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            TYPE: data.TYPE,
            SPK_NM: data.SPK_NM,
            EMOGCODE: data.EMOGCODE || sendData.EMOGCODE,
            SCHDUL_STDT: data.SCHDUL_STDT,
            SCHDUL_ENDT: data.SCHDUL_ENDT,
            ACD_NM: data.ACD_NM,
            BIGO: data.BIGO,
        }));
    }, [data]);

    const save = async () => {
        const requiredFields = [
            { key: 'TYPE', label: '구분' },
            { key: 'SPK_NM', label: '발표자명' },
            { key: 'SCHDUL_STDT', label: '시작일자' },
            { key: 'SCHDUL_ENDT', label: '종료일자' },
            { key: 'ACD_NM', label: '학회명' },
        ];

        for (const field of requiredFields) {
            const value = searchParams[field.key];
            if (value === '' || value === null || value === undefined) {
                alert(`${field.label}을(를) 입력(선택)해야합니다.`);
                return;
            }
        }

        const confirmMessage = sendData.flag === "add" ? "저장하시겠습니까?" : "수정하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);
        if (!confirmed) return;

        const addParams = {
            userAuth: localStorage.getItem("userAuth"),
            DETAIL_SN: data.DETAIL_SN || '',
        };

        const totalObj = Object.assign({}, searchParams, addParams);
        try {
            const response = await axios.get("/trmsapi/trnlst/trnAbstPstSave.do", {
                params: totalObj
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    };


    return (
        <div className='popup_container bg_tr_bg'>
            <div className='flex justify-between'>
                <h5 className='sub_title m-0 p-0'>연구 - 초록 및 포스터</h5>
                <div className='flex gap-1'>
                    <button onClick={save} title='저장' className='search_btn bg_tr_primary justify-self-end'>
                        <Icons.Save16w />{sendData.flag === 'add' ? '저장' : '수정'}
                    </button>
                </div>
            </div>
            <div className='com-search tr_pop_th_bg border-l border-r'>
                <form>
                    <hr className='border-t-2 tr_border_soft' />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="35%" />
                            <col width="15%" />
                            <col width="35%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>연번</th>
                                <td>{sendData.IEM_ID || ''}</td>
                                <th>구분</th>
                                <td>
                                    <select
                                        id="TYPE"
                                        name="TYPE"
                                        className='w-full'
                                        value={searchParams.TYPE}
                                        onChange={handleChange}
                                    >
                                        <option value="">전체</option>
                                        <option value="A">초록</option>
                                        <option value="B">포스터</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>발표자명</th>
                                <td>
                                    <input
                                        type='text'
                                        name='SPK_NM'
                                        id='SPK_NM'
                                        className='input_style'
                                        value={searchParams.SPK_NM}
                                        onChange={handleChange} />
                                </td>
                                <th>소속</th>
                                <td>
                                    <select
                                        name="EMOGCODE"
                                        id="EMOGCODE"
                                        className='w-full'
                                        value={searchParams.EMOGCODE}
                                        onChange={handleChange}
                                    >
                                        {emogList.map((hosp) => (
                                            <option key={hosp.EMOGCODE} value={hosp.EMOGCODE}>
                                                {hosp.EMOGDESC}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>일정</th>
                                <td>
                                    <input
                                        type="date"
                                        name="SCHDUL_STDT"
                                        value={searchParams.SCHDUL_STDT}
                                        onChange={handleChange}
                                    />
                                    &nbsp;~&nbsp;
                                    <input
                                        type="date"
                                        name="SCHDUL_ENDT"
                                        value={searchParams.SCHDUL_ENDT}
                                        onChange={handleChange}
                                        min={searchParams.SCHDUL_STDT}
                                    />
                                </td>
                                <th>학회명</th>
                                <td>
                                    <input
                                        type='text'
                                        id='ACD_NM'
                                        name='ACD_NM'
                                        className='input_style'
                                        value={searchParams.ACD_NM}
                                        onChange={handleChange} />
                                </td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td colSpan="3">
                                    <textarea
                                        id="BIGO"
                                        name="BIGO"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.BIGO}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div >
    );
}

export default TrnAbst_popup;